// extracted by mini-css-extract-plugin
export default {"iconButton":"IconButton_iconButton__xf6up","tooltip":"IconButton_tooltip__DJVXV"};